(function(){
  function initBesaProduct(root){
    if(!root||root.dataset.besaProductReady==='true')return;
    root.dataset.besaProductReady='true';

    var form=root.querySelector('form.product-form');
    var variantField=form&&form.querySelector('input[name="id"]');
    var selects=Array.prototype.slice.call(root.querySelectorAll('[data-product-option]'));
    var buttons=Array.prototype.slice.call(root.querySelectorAll('[data-besa-option-button]'));
    var price=root.querySelector('[data-product-price]');
    var salePrice=root.querySelector('[data-sale-price]');
    var comparePrice=root.querySelector('[data-compare-price]');
    var addButton=root.querySelector('[data-add-to-cart]');
    var variantsNode=root.querySelector('[data-product-variants]');
    var variants=[];
    try{variants=variantsNode?JSON.parse(variantsNode.textContent||'[]'):[]}catch(e){variants=[]}

    var colorIndex=parseInt(root.dataset.colorOptionIndex,10);
    if(isNaN(colorIndex))colorIndex=-1;

    var gallery=root.querySelector('[data-besa-gallery]');
    var mainImage=gallery&&gallery.querySelector('[data-gallery-main-image]');
    var thumbs=gallery&&gallery.querySelector('[data-gallery-thumbs]');
    var prev=gallery&&gallery.querySelector('[data-gallery-prev]');
    var next=gallery&&gallery.querySelector('[data-gallery-next]');
    var currentLabel=gallery&&gallery.querySelector('[data-gallery-current]');
    var totalLabel=gallery&&gallery.querySelector('[data-gallery-total]');
    var viewport=gallery&&gallery.querySelector('[data-gallery-viewport]');
    var sourceItems=gallery?Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-image]')).map(function(node){
      return{id:node.dataset.mediaId,src:node.dataset.src,thumb:node.dataset.thumb,alt:node.dataset.alt||''};
    }):[];

    var gallerySet=[];
    var galleryIndex=0;

    function norm(value){return String(value||'').toLowerCase().replace(/[^a-z0-9åäö]+/g,'')}
    function unique(items){var seen={};return items.filter(function(item){if(!item||seen[item.id])return false;seen[item.id]=true;return true})}
    function idEnds(item,suffix){return !!(item&&item.id&&String(item.id).slice(-suffix.length)===suffix)}
    function byKnownId(suffix){return sourceItems.find(function(item){return idEnds(item,suffix)})||null}

    function colorHeroMap(){
      var map={};
      variants.forEach(function(v){
        if(colorIndex<0||!v.options||!v.options[colorIndex]||!v.featured_media_id)return;
        var key=norm(v.options[colorIndex]);
        if(!map[key])map[key]=v.featured_media_id;
      });
      return map;
    }

    function imagesForColor(value){
      if(!sourceItems.length)return[];
      if(root.dataset.productId==='16577698267485')return sourceItems.slice();
      if(colorIndex<0)return sourceItems.slice(0,4);

      var key=norm(value);
      var isBlack=key.indexOf('black')!==-1||key.indexOf('svart')!==-1;
      var isWhite=key.indexOf('white')!==-1||key.indexOf('ivory')!==-1||key.indexOf('cream')!==-1||key.indexOf('vit')!==-1;

      /* BESA products are intentionally ordered in Shopify as:
         images 1-4 = Off White, images 5-8 = Deep Black.
         Never sort by media ID here: Shopify gallery order is the source of truth. */
      if(sourceItems.length>=8&&(isWhite||isBlack)){
        return (isBlack?sourceItems.slice(4,8):sourceItems.slice(0,4));
      }

      /* Fallback for older products with fewer than eight images. */
      var heroId=colorHeroMap()[key];
      var hero=heroId?sourceItems.find(function(item){return item.id===heroId}):null;
      var blackFront=byKnownId('76970116809053');
      var whiteFront=byKnownId('76970116776285');
      var blackNeck=byKnownId('76970116743517');
      var whiteNeck=byKnownId('76970116710749');
      var front=isBlack?blackFront:whiteFront;
      var neck=isBlack?blackNeck:whiteNeck;
      if(hero)return unique([hero,front,neck]).slice(0,4);
      if(isBlack)return unique([blackFront,blackNeck]).slice(0,4);
      if(isWhite)return unique([whiteFront,whiteNeck]).slice(0,4);
      return sourceItems.slice(0,4);
    }

    function renderGallery(value){
      if(!gallery||!mainImage||!thumbs)return;
      gallerySet=imagesForColor(value);
      galleryIndex=0;
      thumbs.innerHTML='';
      gallerySet.forEach(function(item,index){
        var button=document.createElement('button');
        button.type='button';
        button.className='besa-gallery-thumb'+(index===0?' is-active':'');
        button.setAttribute('aria-label','View image '+(index+1));
        button.dataset.galleryIndex=String(index);
        var img=document.createElement('img');
        img.src=item.thumb||item.src;
        img.alt='';
        img.loading='lazy';
        button.appendChild(img);
        button.addEventListener('click',function(){showImage(index)});
        thumbs.appendChild(button);
      });
      showImage(0);
      var multi=gallerySet.length>1;
      if(prev)prev.hidden=!multi;
      if(next)next.hidden=!multi;
      if(totalLabel)totalLabel.textContent=String(gallerySet.length||0);
    }

    function showImage(index){
      if(!gallerySet.length){
        if(mainImage)mainImage.hidden=true;
        if(currentLabel)currentLabel.textContent='0';
        if(totalLabel)totalLabel.textContent='0';
        return;
      }
      galleryIndex=(index+gallerySet.length)%gallerySet.length;
      var item=gallerySet[galleryIndex];
      mainImage.hidden=false;
      mainImage.src=item.src;
      mainImage.alt=item.alt;
      Array.prototype.slice.call(thumbs.querySelectorAll('.besa-gallery-thumb')).forEach(function(btn,i){
        var active=i===galleryIndex;
        btn.classList.toggle('is-active',active);
        btn.setAttribute('aria-current',active?'true':'false');
      });
      if(currentLabel)currentLabel.textContent=String(galleryIndex+1);
    }

    function moveGallery(step){if(gallerySet.length>1)showImage(galleryIndex+step)}
    if(prev)prev.addEventListener('click',function(){moveGallery(-1)});
    if(next)next.addEventListener('click',function(){moveGallery(1)});

    if(viewport){
      var startX=null;
      viewport.addEventListener('pointerdown',function(e){startX=e.clientX});
      viewport.addEventListener('pointerup',function(e){if(startX===null)return;var delta=e.clientX-startX;startX=null;if(Math.abs(delta)>35)moveGallery(delta<0?1:-1)});
      viewport.addEventListener('pointercancel',function(){startX=null});
      viewport.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){e.preventDefault();moveGallery(-1)}if(e.key==='ArrowRight'){e.preventDefault();moveGallery(1)}});
    }

    function syncButtons(index,value){
      buttons.filter(function(btn){return Number(btn.dataset.optionIndex)===index}).forEach(function(btn){
        var active=btn.dataset.optionValue===value;
        btn.classList.toggle('is-active',active);
        btn.setAttribute('aria-pressed',active?'true':'false');
      });
      var current=root.querySelector('[data-option-current="'+index+'"]');
      if(current)current.textContent=value;
    }

    function selectedColor(){var colorSelect=selects.find(function(item){return Number(item.dataset.optionIndex)===colorIndex});return colorSelect?colorSelect.value:''}

    function updateVariant(){
      if(!variantField||!addButton)return;
      var selected=selects.map(function(select){return select.value});
      var variant=variants.find(function(item){return item.options&&item.options.length===selected.length&&item.options.every(function(value,index){return value===selected[index]})});
      if(variant){
        variantField.value=variant.id;
        if(salePrice)salePrice.textContent=variant.formatted_price;
        else if(price)price.textContent=variant.formatted_price;
        if(comparePrice){
          if(variant.formatted_compare_price){comparePrice.textContent=variant.formatted_compare_price;comparePrice.hidden=false;}
          else{comparePrice.textContent='';comparePrice.hidden=true;}
        }
        addButton.disabled=!variant.available;
        addButton.textContent=variant.available?addButton.dataset.addLabel:addButton.dataset.soldLabel;
        try{var url=new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url.toString())}catch(e){}
      }else{
        variantField.value='';
        addButton.disabled=true;
        addButton.textContent=addButton.dataset.unavailableLabel;
      }
    }

    buttons.forEach(function(button){
      button.addEventListener('click',function(){
        var index=Number(button.dataset.optionIndex);var value=button.dataset.optionValue;
        var select=selects.find(function(item){return Number(item.dataset.optionIndex)===index});
        if(!select)return;
        select.value=value;syncButtons(index,value);if(index===colorIndex)renderGallery(value);updateVariant();
      });
    });

    selects.forEach(function(select){select.addEventListener('change',function(){var index=Number(select.dataset.optionIndex);syncButtons(index,select.value);if(index===colorIndex)renderGallery(select.value);updateVariant()})});

    var qtyInput=root.querySelector('[data-qty-input]');
    var minus=root.querySelector('[data-qty-minus]');
    var plus=root.querySelector('[data-qty-plus]');
    function quantity(){var value=parseInt(qtyInput&&qtyInput.value,10);return isNaN(value)||value<1?1:value}
    if(minus&&qtyInput)minus.addEventListener('click',function(){qtyInput.value=Math.max(1,quantity()-1)});
    if(plus&&qtyInput)plus.addEventListener('click',function(){qtyInput.value=quantity()+1});
    if(qtyInput)qtyInput.addEventListener('change',function(){qtyInput.value=quantity()});

    selects.forEach(function(select){syncButtons(Number(select.dataset.optionIndex),select.value)});
    renderGallery(selectedColor());
    updateVariant();
  }

  document.querySelectorAll('[data-product-root]').forEach(initBesaProduct);
  document.addEventListener('shopify:section:load',function(event){var root=event.target.matches&&event.target.matches('[data-product-root]')?event.target:event.target.querySelector&&event.target.querySelector('[data-product-root]');if(root)initBesaProduct(root)});
})();